import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { isVNode as u, Comment as o, Fragment as i } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function n(e) {
  return e.some((r) => u(r) ? !(r.type === o || r.type === i && !n(r.children)) : !0) ? e : null;
}
function m(e, r) {
  return e && n(e()) || r();
}
function p(e, r, t) {
  return e && n(e(r)) || t(r);
}
function a(e, r) {
  const t = e && n(e());
  return r(t || null);
}
function c(e) {
  return !(e && n(e()));
}
export {
  n as ensureValidVNode,
  c as isSlotEmpty,
  m as resolveSlot,
  p as resolveSlotWithTypedProps,
  a as resolveWrappedSlot
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/vue/resolve-slot.js
// module id = 29
// module chunks = 41